import { useEffect, useState, useMemo } from 'react';

//* Style
import FAQSectionStyle from './style';

//* HOC's
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Components
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import Editor from 'components/common/Editor';
import CollapseItem from 'components/common/Collapse/CollapseItem';
import CollapseContainer from 'components/common/Collapse/CollapseContainer';

const FAQSection = ({ global, items, selectedLang }) => {
	//! Global Data
	const globalData = useMemo(() => global?.[selectedLang], [global, selectedLang]);

	return items.length ? (
		<FAQSectionStyle>
			<Container
				row
				first
				section>
				<div className='faq-title-wrapper col-4 col-t-12'>
					<div className='faq-title-inner-wrapper'>
						<Text className={'minion3-medium h4 primary-color9 uppercase faq-title'}>
							{globalData.faq.title}
						</Text>
						{globalData.faq.description ? (
							<Text className={'notoSans-medium p p3 primary-color9 faq-description'}>
								{globalData.faq.description}
							</Text>
						) : null}
					</div>
				</div>

				<div className='empty-col col-1 col-t-12' />

				<div className='faq-content-wrapper col-7 col-t-12'>
					<div className='faq-content-inner-wrapper'>
						<CollapseContainer>
							{items.map((i, k) => (
								<CollapseItem
									key={k}
									title={
										<>
											<Text className={'minion3-medium p p1 primary-color9 uppercase'}>
												{i.question}
											</Text>

											<div className='plus-minus-icon' />
										</>
									}
									description={<Editor data={i.answer} />}
								/>
							))}
						</CollapseContainer>
					</div>
				</div>
			</Container>
		</FAQSectionStyle>
	) : null;
};

export default withLanguageContext(withDataContext(FAQSection, ['global']), ['selectedLang']);
